export default "__VITE_ASSET__JFwtPYS2__"